import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { injectIntl, intlShape } from 'react-intl';
import { withStyles, Portal } from '@material-ui/core';
import { shapes } from '@greenville/framework';
import { Alert } from '@material-ui/lab';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';
import NotificationModel from './NotificationModel';
import styles from './NotificationStyles';

/*
Alert object details :
  open - true/false
  type - error/warning/info/success
  message - text (priority: if present, show as-is)
  langMessage - language key(s) (string or array of strings)
  duration - alert will be visible for given time
*/
const Notification = ({ classes, notificationState, language, intl }) => {
  const { open, type, message, langMessage, duration } = notificationState;

  const translateKey = (key) => {
    try {
      return intl.formatMessage(language.getText(key));
    } catch (error) {
      return key;
    }
  };

  const getDisplayMessage = () => {
    if (message) return message;
    if (!langMessage) return '';

    const langMessageArray = toJS(langMessage);

    if (Array.isArray(langMessageArray)) {
      return langMessageArray
        .map((item) => (typeof item === 'string' && item.includes('.') ? translateKey(item) : item))
        .join(' ');
    }

    return translateKey(langMessageArray);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    notificationState.set({
      open: false,
      type: '',
      message: '',
      langMessage: '',
      duration: 0
    });
  };

  return (
    <Portal>
      <Snackbar
        className={classes.root}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
      >
        <Alert className={classes.msgStyle} severity={type} onClose={handleClose}>
          {getDisplayMessage()}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

Notification.propTypes = {
  classes: PropTypes.object.isRequired,
  notificationState: shapes.modelOf(NotificationModel).isRequired,
  language: shapes.language.isRequired,
  intl: intlShape.isRequired
};

export default withStyles(styles)(injectIntl(inject('notificationState', 'language')(observer(Notification))));
